"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeMarkdownProcessor = void 0;
const marked_1 = __importDefault(require("marked"));
class AlmeMarkdownProcessor {
    static ConvertAlmeResponse(response) {
        const responseText = this.escapeAlmeDisplayLink(response);
        return Object.assign(Object.assign({}, response), { html: this.MarkUp(responseText) });
    }
    static MarkUp(inText) {
        return inText ? marked_1.default.marked(inText) : inText;
    }
    static getLinkSpec(sections, matches) {
        const [displayText, sectionIndexStr, linkIndexStr] = matches.slice(1);
        // Convert from string to number or bail
        let linkIndex = parseInt(linkIndexStr, 10);
        if (isNaN(linkIndex)) {
            return null;
        }
        // Convert from string to number or bail
        // Also bail if index is -1 (i.e., not found)
        // Can't just .find() here because we might have to subtract
        let foundSectionIndex = parseInt(sectionIndexStr, 10);
        if (isNaN(foundSectionIndex)) {
            foundSectionIndex = sections.findIndex((section) => {
                if (linkIndex < section.Links.length) {
                    return true;
                }
                linkIndex -= section.Links.length;
            });
            if (foundSectionIndex < 0) {
                return null;
            }
        }
        const foundSection = sections[foundSectionIndex];
        if (!foundSection) {
            return null;
        }
        const link = foundSection.Links[linkIndex] || null;
        // Override text when specified
        if (link && displayText) {
            link.DisplayText = displayText;
        }
        return link;
    }
    static updateDisplayLinkSection(sections, link) {
        return sections.map((section) => {
            const displayLinks = section.Links;
            displayLinks.forEach(displayLink => {
                //Add field to metadata if inline
                if (displayLink.Metadata['UrlUID'] === (link === null || link === void 0 ? void 0 : link.Metadata['UrlUID'])) {
                    displayLink.Metadata = Object.assign(Object.assign({}, displayLink.Metadata), { isInline: true });
                }
            });
            section.Links = displayLinks;
            return section;
        }).filter((section) => {
            // remove sections without any links.
            return !!section.Links.length;
        });
    }
    static escapeAlmeDisplayLink(response) {
        const sections = response.displayLinkCollection ? response.displayLinkCollection.Sections : [];
        const sectionCopy = JSON.parse(JSON.stringify(sections));
        let { text } = response;
        let matches;
        // eslint-disable-next-line no-cond-assign
        while (matches = this.patterns.link.exec(text)) {
            const link = this.getLinkSpec(sectionCopy, matches);
            if (link) {
                switch (link.TargetType) {
                    case 'Url':
                        text = text.replace(matches[0], `[${link.DisplayText}](${link.Metadata.UrlAddress})`);
                        if (response.displayLinkCollection) {
                            response.displayLinkCollection.Sections = this.updateDisplayLinkSection(response.displayLinkCollection.Sections, link);
                        }
                        break;
                    case 'Unit':
                        break;
                    case 'Input':
                    default:
                        // TODO: add support for Alme inline input/url links.
                        // for now replace with link text and leave as attached links.
                        text = text.replace(matches[0], matches[1]);
                        // Consider using lexer extensibility to make this work (https://marked.js.org/#/USING_PRO.md#lexer).
                        // text = text + `\n[${matches[3]}]: ${matches[2]} ${matches[1]}`;
                        break;
                }
            }
            else {
                text = text.replace(matches[0], matches[1]);
            }
        }
        return text;
        // return text ? text.replace(this.patterns.link, '\\$&') : text;
    }
}
exports.AlmeMarkdownProcessor = AlmeMarkdownProcessor;
AlmeMarkdownProcessor.patterns = {
    link: /\[([^\][]+)\]\((?:(\d{1,2}),)?(\d{1,2})?\)/ig,
};
//# sourceMappingURL=AlmeMarkdownProcessor.js.map